export const FRENCH_DAY_NAMES_MIN = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
export const FRENCH_MONTH_NAMES = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];
